import { useCallback, useState, useMemo } from 'react';
import { WebBlocksApiBlockT } from '../lib/REST/types';

export default function useWebBlocksApi(
	promiseCreator: (...args: any) => Promise<any>
): [
	{
		result: WebBlocksApiBlockT[] | undefined;
		error: Error | undefined;
		isFetching: boolean;
	},
	(opts: any) => Promise<void>
] {
	const [result, setResult] = useState<WebBlocksApiBlockT[] | undefined>(
		undefined
	);
	const [isFetching, setFetching] = useState(true);
	const [error, setError] = useState<Error | undefined>(undefined);

	const apiCallback = useCallback(async (data: any) => {
		setError(undefined);
		setFetching(true);
		try {
			const dataFromApi = await promiseCreator(data);
			if (dataFromApi.data !== null) {
				setResult(dataFromApi.data);
			} else {
				const apiFailedError = new Error('Fetch data from api failed.');
				apiFailedError.name = 'Api failed error';
				setError(apiFailedError);
				setFetching(false);
			}
		} catch (myError: any) {
			setError(myError);
		}
		setFetching(false);
	}, []);

	const apiResponse = useMemo(
		() => ({ result, error, isFetching }),
		[result, error, isFetching]
	);

	return [apiResponse, apiCallback];
}
